import { BarcodeOutlined } from "@ant-design/icons";
import { Col, Form, Input, Modal, Row, message } from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { UseMutateAsyncFunction } from "react-query";
import { useDispatch } from "react-redux";
import { mainActions } from "../../../../store/main/mainSlice";
import { AxiosResponse } from "axios";
import Title from "../../../UI/Title/Title";
import ItemNotFoundModal from "../ItemNotFoundModal/itemnotfoundmodal";
import { checkItemQuantityFunctionContext } from "../../MainFour";

interface AddEditModall {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  getItemByBarcodeMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any> | undefined,
    unknown,
    string,
    unknown
  >;
}
const AddItemModal = ({
  open,
  setOpen,
  getItemByBarcodeMutation,
}: AddEditModall) => {
  const [t] = useTranslation("common");
  const dispatch = useDispatch();
  const [isOpenNotFound, setIsOpenNotFound] = useState(false);
  const [barcode, setBarcode] = useState<string>("");
  const [quantity, setQuantity] = useState<number>(1);
  const [, contextHolder] = message.useMessage();
  const qtyInputRef = useRef<any>(null);
  const barcodeInputRef = useRef<any>(null);

  const error = () => {
    setIsOpenNotFound(true);
    document.body.classList.add("body-scroll-lock");
  };
  const addItem = (item: any) => {
    dispatch(
      mainActions.addItem({
        name: item?.item.name,
        itemId: item?.item.id,
        barcode: item?.item.barcode,
        cost: item?.averageCost,
        price: item?.averagePrice,
        totalPrice: item?.averagePrice,
        isTaxable: item?.item.isTaxable,
        extraCharge: 0,
        tax: 10,
        discount: null,
        notes: "Example sale item notes",
        qty: quantity
          ? quantity >= item?.currentQuantity
            ? item?.currentQuantity
            : quantity
          : 1,
        qtyInStock: item?.currentQuantity,
        specifications: [],
      })
    );
  };
  useEffect(() => {
    setTimeout(() => {
      open && qtyInputRef?.current?.focus();
    }, 0);
  }, [open]);
  return (
    <>
      {contextHolder}
      <Modal
        centered
        open={open}
        closable={false}
        maskClosable={false}
        width={400}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
          },
          htmlType: "submit",
          form: "formdiscount",
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        cancelText={t('cancel')}
        okText={`${t("ok")}`}
        onCancel={() => {
          setOpen(false);
          setQuantity(1);
          setBarcode("");
          // add scroll
          document.body.classList.remove("body-scroll-lock");
        }}
        onOk={() => {
          if (!barcode) return;
          getItemByBarcodeMutation(barcode)
            .then((res) => {
              const item = res?.data;
              addItem(item);
              setOpen(false);
              setQuantity(1);
            })
            .catch(() => {
              error();
            })
            .finally(() => setBarcode(""));
          document.body.classList.remove("body-scroll-lock");
        }}
      >
        <Form id="formdiscount" layout="vertical">
          <Row>
            <Col offset={1} span={20}>
              <Col offset={1} span={23}>
                <Title title={`${t("add-quantity")}`} />
              </Col>
              <Col span={24}>{t("barcode")}</Col>

              <Input
                ref={barcodeInputRef}
                type="number"
                className="btn-shadow"
                placeholder={`${t("barcode")}`}
                value={barcode}
                onChange={(e: any) => {
                  setBarcode(e.target.value);
                }}
                suffix={
                  <BarcodeOutlined
                    style={{ fontSize: "20px", color: "#8C8C8C" }}
                  />
                }
              />

              <Col style={{ paddingTop: "10px" }} span={24}>
                {t("quantity")}
              </Col>

              <Input
                ref={qtyInputRef}
                onPressEnter={() => {
                  barcodeInputRef.current.focus();
                }}
                onBlur={(e) => {
                  const inputValue = e.target.value;
                  if (Number(inputValue) === 0) {
                    setQuantity(1);
                  }
                }}
                value={quantity}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  const numericValue = /^\d+$/.test(inputValue)
                    ? inputValue
                    : 0;
                  setQuantity(Number(numericValue));
                }}
                placeholder="Enter Quantity"
                type="number"
              />
            </Col>
          </Row>
        </Form>
      </Modal>
      <ItemNotFoundModal
        isOpenNotFound={isOpenNotFound}
        setIsOpenNotFound={setIsOpenNotFound}
      />
    </>
  );
};

export default AddItemModal;
